import { render, staticRenderFns } from "./ReceiptPrintOrder.vue?vue&type=template&id=408fc736"
import script from "./ReceiptPrintOrder.vue?vue&type=script&lang=js"
export * from "./ReceiptPrintOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports